module.exports = __webpack_public_path__ + "static/media/Maryann P.0124a475.jpg";